/*
 * Weekplan Messages
 *
 * This contains all the text for the Weekplan component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  finalizeWeekSuccess: {
    id: 'app.containers.FinalizeWeekMenuItem.finalizeWeekSuccess',
    defaultMessage: 'Successfully published week assignments',
  },
  finalizeWeekFailure: {
    id: 'app.containers.FinalizeWeekMenuItem.finalizeWeekFailure',
    defaultMessage: 'Error. Failed publishing week assignments.',
  },
  finalizeWeek: {
    id: 'app.containers.FinalizeWeekMenuItem.finalizeWeek',
    defaultMessage: 'Publish week assignments',
  },
  finalizeWeekConfirmationTitle: {
    id: 'app.containers.FinalizeWeekMenuItem.finalizeWeekConfirmationTitle',
    defaultMessage: 'Publish week assignments?',
  },
  finalizeWeekConfirmationText: {
    id: 'app.containers.FinalizeWeekMenuItem.finalizeWeekConfirmationText',
    defaultMessage:
      'By publishing the week you make the assignments in this week public to all attendees.',
  },
  finalizeWeekConfirmationButton: {
    id: 'app.containers.FinalizeWeekMenuItem.finalizeWeekConfirmationButton',
    defaultMessage: 'Publish week assignments',
  },
  finalizeWeekConfirmationCancel: {
    id: 'app.containers.FinalizeWeekMenuItem.finalizeWeekConfirmationCancel',
    defaultMessage: 'Cancel',
  },
});
